<template>
	<b-row class="calendar-container m-0">
		<b-col cols="12" class="p-0">
			<b-row class="title-row m-0">
				<b-col lg="auto" cols="6" class="customer-title p-0">
					Customer Name
					<b-form-input v-model="customerSearch" class="h-50 mt-1" placeholder="search"></b-form-input>
				</b-col>
				<b-col v-for="(rangeDate, index) in rangeDates" :key="index" class="calendar-title p-0">
					<b>{{formatCalendarTitle(rangeDate.date)}}</b>
					<br />
					{{rangeDate.totalHours}}
				</b-col>
			</b-row>
			<b-row v-for="(customer, index) in customers" :key="index" class="customer-row m-0" align-v="stretch">
				<b-col lg="auto" cols="6" class="client p-0">
					<b-row align-v="stretch">
						<b-col cols="9" class="name p-0" align-self="center">
							{{customer.name}}
						</b-col>
						<b-col class="time p-0" align-self="center">
							{{customer.totalHours}}
						</b-col>
					</b-row>
				</b-col>
				<b-col v-for="(rangeDate, index2) in rangeDates"
					   :key="index2"
					   @click="showNewShiftForm($event, customer, rangeDate.date)"
					   @drop="onShiftDrop($event, rangeDate.date)"
					   @dragover.prevent
					   @dragenter.prevent
					   :title="`Click to add new shift for ${customer.name} on ${moment(rangeDate.date).format('ddd, DD MMM YYYY')}`"
					   class="shift-square p-0">
					<div v-for="(shift, index3) in rangeDate.shifts" :key="index3" class="shift-container" @dragstart="onShiftDrag($event, shift)" draggable>
						<div v-if="customer.id == shift.clientid"
							 :class="`shift ${shift.statusColor}`"
							 @click="onShiftClick($event, shift)"
							 :title="`Click to view. Double click to edit. Drag to change date${shift.error != null ? `\nErrors:\n${shift.error}` : ''}`">
							<div v-if="shift.istimeclock" class="name" v-html="`${shift.shifttask}${(shift.servicetypename == '' ? '' : ' - ' + shift.servicetypename)}`"></div>
							<div v-else class="name">{{shift.shiftname}}</div>
							<div class="time">{{moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A").format("hh:mm a")}}</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-col>

		<b-modal ref="forms" :visible="isShowingShiftForm"
				 @hide="hideShiftForm"
				 size="lg"
				 :modal-class="'shift-form' + (creating ? ' creating': ' editing')"
				 body-class="mh-off-middle"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">{{moment(selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("dddd, MMM D, YYYY")}}</h5>
			</template>
			<template slot="default">
				<ShiftForm @close-form="hideShiftForm" @save-form="saveShift" :data="selectedRecord" />
			</template>
		</b-modal>

		<b-modal ref="forms" :visible="isShowingCancelShiftForm"
				 @hide="hideCancelShiftForm"
				 size="lg"
				 modal-class="shift-form cancel"
				 body-class="mh-off-middle"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">Cancel shift for {{selectedRecord.clientfullname}} on {{moment(selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("dddd, MMM D, YYYY")}}</h5>
			</template>
			<template slot="default">
				<CancelShiftForm @close-form="hideCancelShiftForm" @save-form="cancelShift" :data="selectedRecord" />
			</template>
		</b-modal>

		<b-modal v-if="isShowingShiftSummary"
				 :visible="isShowingShiftSummary"
				 @hide="hideShiftSummary"
				 size="md"
				 modal-class="shift-summary"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">{{moment(selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("dddd, MMM D, YYYY")}}</h5>
			</template>
			<template slot="default">
				<ShiftDetails :data="selectedRecord"
							  @cancel-shift="showCancelShiftForm(selectedRecord)"
							  @edit-shift="showEditShiftForm(selectedRecord)"
							  @delete-shift="deleteShift(selectedRecord)" />
			</template>
		</b-modal>
	</b-row>
</template>

<script>
	import ShiftForm from "./ShiftForm"
	import ShiftDetails from "./ShiftDetails"
	import CancelShiftForm from "./CancelShiftForm"
	import moment from "moment"

	export default {
		name: 'ScheduleBoard',
		components: {
			ShiftForm,
			ShiftDetails,
			CancelShiftForm
		},
		props: {
			date: null,
			period: null,
			filters: null
		},
		data: function () {
			return {
				customerSearch: "",
				gettingShifts: false,
				shiftClickCount: 0,
				viewing: false,
				creating: false,
				editing: false,
				cancelling: false,
				selectedRecord: {
					servicedate: moment().format("D/MM/YYYY hh:mm:ss A")
				}
			}
		},
		mounted: function () {
			this.getShifts()
		},
		watch: {
			date: {
				immediate: true,
				handler(newValue, oldValue) {
					if (oldValue != undefined) {
						this.gettingShifts = false

						this.getShifts()
					}
				}
			},
			period: {
				immediate: true,
				handler(newValue, oldValue) {
					this.getShifts()
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			shifts: function () {
				return this.getFilteredShifts(this.$store.state.Shifts.shifts)
			},
			customers: function () {
				var shifts = this.getFilteredShifts(this.$store.state.Shifts.shifts)

				return this.$store.state.Customers.customers
					.slice()
					.filter(x => {
						return (!this.filters.clientsWithShiftsOnly
							|| (this.filters.clientsWithShiftsOnly
								&& shifts.some(y => y.clientid == x.id)))
							&& (this.customerSearch === ""
							|| (this.customerSearch !== ""
								&& x.name.toLowerCase().indexOf(this.customerSearch.toLowerCase()) > -1))
					})
					.sort(this.$store.getters["Helper/compareValues"]("name", "asc"))
					.map((customer, index) => {
						var filteredShifts = shifts.filter(x => x.clientid == customer.id)
						var totalHours = filteredShifts.reduce(function (a, b) {
							return parseFloat(a) + parseFloat(b.totalhours)
						}, 0)

						var duration = moment.duration(totalHours, 'hours')

						customer.totalHours = `${duration.hours().toString().padStart(2, '0')}:${duration.minutes().toString().padStart(2, '0')}`

						return customer
					})
			},
			rangeDates: function () {
				var dates = []
				var day = moment(this.dateFrom);

				while (day < moment(this.dateTo)) {
					var shifts = this.shifts.filter(x => moment(x.servicedate, "DD/MM/YYYY").format("DD/MM/YYYY") == day.format("DD/MM/YYYY"))
					var totalHours = shifts.reduce(function (a, b) {
						return parseFloat(a) + parseFloat(b.totalhours)
					}, 0)

					var duration = moment.duration(totalHours, 'hours')

					dates.push({
						date: day.toDate(),
						shifts: shifts,
						totalHours: `${duration.hours().toString().padStart(2, '0')}:${duration.minutes().toString().padStart(2, '0')}`
					})

					day = day.clone().add(1, 'd')
				}

				return dates
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			selectedRecordCustomer: function () {
				return this.customers.filter(x => x.id == this.selectedRecord.clientid)[0]
			},
			customerProfilePicture: function () {
				return this.selectedRecordCustomer.profilepic
			},
			dateFrom: function () {
				return this.date
			},
			dateTo: function () {
				var date = moment(this.date).add(this.period.number, this.period.type).toDate()

				if (this.period.title == "Fortnight")
					date = moment(this.date).add(-1, "days").add(this.period.number, this.period.type).toDate()

				return date
			},
			statusValues: function () {
				return this.$store.state.Shifts.statusValues
			},
			statusColors: function () {
				return this.$store.state.Shifts.statusColors
			},
			isShowingShiftForm: function () {
				return !this.viewing && (this.creating || this.editing)
			},
			isShowingCancelShiftForm: function () {
				return !this.viewing && this.cancelling
			},
			isShowingShiftSummary: function () {
				return this.viewing
			}
		},
		methods: {
			formatCalendarTitle: function (date) {
				var formattedDate = moment(date).format("ddd, DD")

				if (this.period.title == "Day")
					formattedDate = moment(date).format("DD MMM YYYY")

				return formattedDate
			},
			getShifts: function () {
				return new Promise(async (resolve, reject) => {
					try {
						var $this = this

						if (this.gettingShifts || this.$store.state.Customers.customers.length < 1)
							return

						this.gettingShifts = true

						this.$store.dispatch(
							"Shifts/getShiftsForRange",
							{
								fromDate: moment(this.dateFrom).format('YYYY-MM-DD'),
								toDate: moment(this.dateTo).format('YYYY-MM-DD'),
								showLoading: true
							}
						).then(function () {
							$this.$emit("shifts", $this.shifts)
							$this.gettingShifts = false

							resolve()
						})
					}
					catch {
						reject()
					}
				})
			},
			getFilteredShifts: function (shifts) {
				return shifts
					.filter(shift => {
						return (this.filters.status.pending && shift.allStatuses == this.statusValues.pending)
							|| (this.filters.status.unconfirmed && shift.allStatuses == this.statusValues.unconfirmed)
							|| (this.filters.status.scheduled && shift.allStatuses == this.statusValues.scheduled)
							|| (this.filters.status.completed && shift.allStatuses == this.statusValues.completed)
							|| (this.filters.status.cancelled && shift.allStatuses == this.statusValues.cancelled)
							|| (this.filters.status.unpublished && shift.allStatuses == this.statusValues.unpublished)
							|| (this.filters.status.error && shift.allStatuses == this.statusValues.error)
					})
			},
			onShiftClick: function (event, shift) {
				event.stopPropagation()

				this.shiftClickCount++

				if (this.shiftClickCount == 1) {
					var $this = this

					this.$store.dispatch(
						"Timeouts/set",
						{
							name: "ShiftScheduleBoardCustomer",
							callback: function () {
								$this.showShiftSummary(shift)
								$this.shiftClickCount = 0
							},
							timeout: 500
						})
				}
				else {
					this.$store.commit("Timeouts/clear", "ShiftScheduleBoardCustomer")
					this.showEditShiftForm(shift)
					this.shiftClickCount = 0
				}
			},
			onShiftDrag: function (event, shift) {
				this.selectedRecord = shift
			},
			onShiftDrop: function (event, date) {
				var serviceDate = moment(`${moment(date).format("DD/MM/YYYY")} ${moment(this.selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("hh:mm:ss A")}`, "D/MM/YYYY hh:mm:ss A")
				var difference = moment(date).diff(moment(this.selectedRecord.servicedate, "DD/MM/YYYY"))
				var endDate = moment(this.selectedRecord.enddate, "D/MM/YYYY hh:mm:ss A").add(moment.duration(difference).days(), "days")

				var parameters = {
					id: this.selectedRecord.servicescheduleid,
					name: this.selectedRecord.name,
					userId: this.selectedRecord.employeeid,
					clientId: this.selectedRecord.clientid,
					start: serviceDate.format("HH:mm"),
					end: endDate.format("HH:mm"),
					date: serviceDate.format("YYYY-MM-DD"),
					dateTo: endDate.format("YYYY-MM-DD"),
					serviceTypeId: this.selectedRecord.servicetypeid,
					billable: !this.selectedRecord.istimeclock,
					days: "",
					interval: 0,
					shiftNotes: this.shiftnotes,
					SendEmailNotification: false,
					CreateShiftWithErrors: true
				}

				var $this = this

				this.$store.dispatch("Shifts/saveShift", parameters).then(function (response) {
					$this.getShifts()
				})

				this.selectedRecord = this.getDefaultShift(0, new Date())
			},
			getDefaultShift: function (id, date) {
				return {
					clientid: id || 0,
					servicedate: moment(date).format("D/MM/YYYY hh:mm:ss A")
				}
			},
			showShiftSummary: function (shift) {
				this.selectedRecord = shift
				this.viewing = true
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			hideShiftSummary: function () {
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			showNewShiftForm: function (event, customer, date) {
				event.stopPropagation()

				this.selectedRecord = this.getDefaultShift(customer.id, date)

				this.viewing = false
				this.creating = true
				this.editing = false
				this.cancelling = false
			},
			showEditShiftForm: function (shift) {
				this.selectedRecord = shift
				this.viewing = false
				this.creating = false
				this.editing = true
				this.cancelling = false
			},
			showCancelShiftForm: function (shift) {
				this.selectedRecord = shift
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = true
			},
			hideShiftForm: function () {
				this.selectedRecord = this.getDefaultShift(0, new Date())
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			hideCancelShiftForm: function () {
				this.selectedRecord = this.getDefaultShift(0, new Date())
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			saveShift: function (response) {
				this.getShifts()
					.then(() => {
						this.selectedRecord = this.shifts.filter(x => x.servicescheduleid === response.shiftids.split(",")[0])[0];
					})
			},
			cancelShift: function () {
				this.getShifts()
				this.hideCancelShiftForm()
			},
			deleteShift: function (obj) {
				if (obj.timesheetapproved == "True") {
					this.$store.commit("Toasts/showWarning", { title: "Shift", content: "Shift is approved and cannot be deleted!" })

					return
				}

				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to delete <b>${obj.clientfullname} - ${obj.shiftname}</b> on <b>${moment(obj.servicedate, "DD/MM/YYYY hh:mm:ss A").format("DD MMM YYYY")}</b> at <b>${moment(obj.servicedate, "DD/MM/YYYY hh:mm:ss A").format("hh:mm A")} - ${moment(obj.enddate, "DD/MM/YYYY hh:mm:ss A").format("hh:mm A")}</b>?`,
					okCallback: () => {
						this.$store.dispatch(
							"Shifts/DeleteShift",
							{
								timesheetId: obj.timesheetid,
								serviceScheduleId: obj.servicescheduleid
							})
							.then(() => {
								this.viewing = false

								this.getShifts()
							})
					},
					cancelCallback: null
				})
			}
		}
	}
</script>

<style>
	.shift-form .modal-content,
	.shift-summary .modal-content {
		border-radius: 16px;
		height: fit-content;
	}

	.shift-form .modal-header,
	.shift-summary .modal-header {
		padding: 10px 20px;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		margin: -1px;
	}

	.shift-summary .modal-header {
		background-color: #081e4a;
	}

		.shift-summary .modal-header .close {
			color: #ffffff !important;
			opacity: 1;
			font-weight: 100;
		}

	.shift-summary .modal-body .row {
		margin: 0;
	}

		.shift-summary .modal-body .row .blurb {
			padding: 15px 20px;
			background-color: #f7f8fa;
			border-radius: 15px;
		}

	.shift-form.creating .modal-header {
		background-color: #e94a79;
	}

	.shift-form.editing .modal-header {
		background-color: #5aba47;
	}

	.shift-form.cancel .modal-header {
		background-color: #081e4a;
	}

	.shift-form .modal-header .modal-title,
	.shift-summary .modal-header .modal-title {
		font-size: 15px;
		color: #ffffff !important;
	}

	.shift-form .modal-header .close {
		color: #ffffff !important;
		opacity: 1;
		font-weight: 100;
	}

	.shift-form .modal-body .row {
		margin: 0 !important;
	}

		.shift-form .modal-body .row > div {
			padding-left: 5px !important;
			padding-right: 5px !important;
		}
</style>
<style scoped>
	.calendar-container {
		font-size: 12px;
	}

		.calendar-container > div .title-row > div {
			min-height: 50px;
		}

		.calendar-container > div > div > div:first-child {
			flex: 0 0 15em;
			vertical-align: middle;
		}

		.calendar-container > div .title-row .customer-title {
			height: 7.5em;
			background-color: #081e4a;
			color: #ffffff;
			border-top-left-radius: 15px;
			border-top-right-radius: 15px;
			white-space: nowrap;
			margin-right: 5px;
			padding: 15px !important;
		}

		.calendar-container > div .title-row .calendar-title {
			flex-direction: row;
			flex-wrap: nowrap;
			font-size: 11px;
			background-color: #eceff5;
			color: #081e4a;
			padding: 10px !important;
		}

			.calendar-container > div .title-row .calendar-title:nth-child(2) {
				border-top-left-radius: 15px;
			}

			.calendar-container > div .title-row .calendar-title:last-child {
				border-top-right-radius: 15px;
			}

		.calendar-container > div .customer-row {
			min-height: 50px;
		}

			.calendar-container > div .customer-row .client {
				border-left: 1px solid #081e4a;
				border-right: 1px solid #081e4a;
				border-bottom: 1px solid #081e4a;
				margin-right: 5px;
				padding: 15px 5px !important;
			}

			.calendar-container > div .customer-row:last-child .client:first-child {
				border-bottom-left-radius: 15px;
				border-bottom-right-radius: 15px;
			}

			.calendar-container > div .customer-row .client > div {
				margin: 0;
			}

				.calendar-container > div .customer-row .client > div .time {
					text-align: right;
				}

			.calendar-container > div .customer-row .shift-square {
				border-left: 1px solid #f3f5f8;
				border-bottom: 1px solid #f3f5f8;
				padding: 15px 0 !important;
			}

				.calendar-container > div .customer-row .shift-square:last-child {
					border-right: 1px solid #f3f5f8;
				}

			.calendar-container > div .customer-row:last-child .shift-square:nth-child(2) {
				border-bottom-left-radius: 15px;
			}

			.calendar-container > div .customer-row:last-child .shift-square:last-child {
				border-bottom-right-radius: 15px;
			}

			.calendar-container > div .customer-row .shift-square .shift-container .shift {
				float: left;
				width: 100%;
				border: 1px solid #f3f5f8;
				font-size: 11px;
				cursor: pointer;
				padding: 5px;
				word-break: break-word;
				line-height: 1.5em;
			}

				.calendar-container > div .customer-row .shift-square .shift-container .shift .time {
					filter: brightness(95%);
				}
</style>